export default {
  name: 'rb-3d-toggle-provider',
  functional: true,
  props: {
    index: {
      type: Number,
      default: 0,
    },
    onClick: {
      type: Function,
      default: () => ({}),
    },
    activeToggle: {
      type: Number,
      default: 0,
    },
    skeletonIsVisible: {
      type: Boolean,
      default: false,
    },
  },
  render(_createElement, { slots, props }) {
    const index = props.index
    const filteredSlots = (slots().default || [])?.filter((slot) => !!slot.tag)
    const currentSlot = filteredSlots[index]
    const toggleId = currentSlot.componentOptions.propsData.id
    currentSlot.componentOptions.propsData.callback = props.onClick
    currentSlot.componentOptions.propsData.isSelected = toggleId === props.activeToggle
    currentSlot.componentOptions.propsData.skeletonIsVisible = props.skeletonIsVisible
    return currentSlot
  },
}
